import React from "react";
import { withRouter } from "react-router-dom";
import { inject } from "mobx-react";
import OperatoryOrderPopup from "Popups/OperatoryOrderPopup";
import { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { SITE101_NOMERA } from "Constants/OrderTypes";
import ConnectButton from "ComponentsUI/BeautifulNumbers/ConnectButton";
import PriceComponent from "ComponentsUI/BeautifulNumbers/PriceComponent";
import ProviderLogo from "ComponentsUI/BeautifulNumbers/ProviderLogo";
import BeautifulNumbersItem from "ComponentsUI/BeautifulNumbers/BeautifulNumbersItem";
import NumberComponent from "ComponentsUI/BeautifulNumbers/NumberComponent";
import { Buttons } from "ComponentsUI/TarifficationM";
import Routes from "Configs/routes";

const BeautifulNumbersRow = (props) => {
	let {
		ApplicationModel: { modalModel, sendingStore, text },
		tariff,
	} = props;

	const onClickHandler = (globalId) => {
		if (globalId == 1874) {
			sendMetriks("CLICK_CONNECT_TINKOFF_NOMERA");
		}
		if (globalId == 1876) {
			sendMetriks("CLICK_CONNECT_BEELINE_NOMERA");
		}
		if (globalId == 1880) {
			sendMetriks("CLICK_CONNECT_MEGAFON_NOMERA");
		}
		if (globalId == 1879) {
			sendMetriks("CLICK_CONNECT_TELE2_NOMERA");
		}
		if (globalId == 1878) {
			sendMetriks("CLICK_CONNECT_YOTA_NOMERA");
		}
		if (globalId == 1873) {
			sendMetriks("CLICK_CONNECT_SBER_NOMERA");
		}
		if (globalId == 1877) {
			sendMetriks("CLICK_CONNECT_MTC_FROM_NOMERA");
		}
		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_CONNECT_NOMERA, []);
	};

	const numberComponent = <NumberComponent value={tariff.phone} />;

	const aboutOperatorLink = generateUrl(Routes.OperatorDetails.route, {
		regionUrl: tariff.provider.region.url,
		operator: tariff.provider.url_name,
	});

	const logoComponent = (
		<ProviderLogo
			path={tariff.provider.logo}
			name={tariff.provider.name}
			link={aboutOperatorLink}
		/>
	);

	const priceComponent = (
		<PriceComponent
			value={tariff.price}
			measure={text.servicesRub}
			mobileBigView={true}
			texts={text}
			freeText={true}
		/>
	);

	const cbo = tariff?.provider?.operator_settings?.numbers?.value;
	const cbou = tariff?.provider?.operator_settings?.numbers?.url;
	let providerGlobalId = tariff?.provider?.global?.id;

	let buttonComponent;

	switch (cbo) {
		case "adviser":
			buttonComponent = (
				<OperatoryOrderPopup
					tariff={tariff}
					modalModel={props.ApplicationModel.modalModel}
					sendingStore={props.ApplicationModel.sendingStore}
					orderType={SITE101_NOMERA}
					text={text}
					ApplicationModel={props.ApplicationModel}
					providerInfo={props.providerInfo}
				>
					<ConnectButton texts={text} onClick={() => onClickHandler(providerGlobalId)} />
				</OperatoryOrderPopup>
			);
			break;
		case "api":
			buttonComponent = (
				<OperatoryOrderPopup
					tariff={tariff}
					modalModel={props.ApplicationModel.modalModel}
					sendingStore={props.ApplicationModel.sendingStore}
					orderType={SITE101_NOMERA}
					text={text}
					ApplicationModel={props.ApplicationModel}
					providerInfo={props.providerInfo}
					apiOnly={true}
				>
					<ConnectButton texts={text} onClick={() => onClickHandler(providerGlobalId)} />
				</OperatoryOrderPopup>
			);
			break;
		case "url":
			if (cbou) {
				buttonComponent = (
					<ConnectButton
						texts={text}
						connectURL={cbou}
						alt_text={true}
						onClick={() => onClickHandler(providerGlobalId)}
					/>
				);
			}
			break;
		case "disabled":
			buttonComponent = (
				<ConnectButton
					texts={text}
					defaultCursor={true}
					onClick={() => onClickHandler(providerGlobalId)}
				/>
			);
			break;
		default:
			buttonComponent = (
				<ConnectButton
					texts={text}
					defaultCursor={true}
					onClick={() => onClickHandler(providerGlobalId)}
				/>
			);
	}

	return (
		<BeautifulNumbersItem
			numberComponent={numberComponent}
			logoComponent={logoComponent}
			priceComponent={priceComponent}
			buttonComponent={buttonComponent}
		/>
	);
};

export default withRouter(inject("ApplicationModel")(BeautifulNumbersRow));
